var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"type":"error","center":"","show-icon":false}},[_c('div',{staticClass:"h3"},[_vm._v("This page is currently in development.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }